import config from "@/lib/config";
import { useDeviceInfoQuery, useAdultModeQuery } from "@/hooks";
import styles from "@/styles/Video.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export default function AndroidAppDownloadBanner() {
  var _useAdultModeQuery = useAdultModeQuery({
    fetchPolicy: "cache-first"
  }),
      adultMode = _useAdultModeQuery.data.adultMode;

  if (adultMode) return null;

  var _useDeviceInfoQuery = useDeviceInfoQuery({
    fetchPolicy: "cache-first"
  }),
      _useDeviceInfoQuery$d = _useDeviceInfoQuery.data;

  _useDeviceInfoQuery$d = _useDeviceInfoQuery$d === void 0 ? {} : _useDeviceInfoQuery$d;
  var deviceInfo = _useDeviceInfoQuery$d.deviceInfo;

  var _ref = deviceInfo !== null && deviceInfo !== void 0 ? deviceInfo : {},
      isAndroid = _ref.isAndroid;

  if (!isAndroid) return null;
  var href = config.appStoreUrl.android;
  return /*#__PURE__*/_jsx("a", {
    className: styles["getin-googleplay"],
    href: href,
    children: /*#__PURE__*/_jsx("img", {
      alt: "Google Play \u3067\u624B\u306B\u5165\u308C\u3088\u3046",
      src: "/images/google_play_badge.png"
    })
  });
}